import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql, Link } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/checkbox/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <p>{`There are 2 checkbox components, `}<inlineCode parentName="p">{`Checkbox`}</inlineCode>{` and `}<inlineCode parentName="p">{`LabeledCheckbox`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`Checkbox`}</inlineCode>{` is a square box that is empty, checked or has an intermediate state. You normally don’t want to use it directly except for very custom UI designs that cannot be fulfilled with `}<inlineCode parentName="p">{`LabeledCheckbox`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`LabeledCheckbox`}</inlineCode>{` is a `}<inlineCode parentName="p">{`Checkbox`}</inlineCode>{` with a `}<inlineCode parentName="p">{`Label`}</inlineCode>{`. The label can be on the left or right side of the checkbox.`}</p>
    <h2>{`States`}</h2>
    <p>{`Empty Checkbox `}<img parentName="p" {...{
        "src": "/img/ios/checkbox_empty.png",
        "alt": "Empty Checkbox",
        "title": "Empty Checkbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let checkbox = Checkbox()
`}</code></pre>
    <p>{`Empty LabeledCheckbox `}<img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_empty.png",
        "alt": "Empty LabeledCheckbox",
        "title": "Empty LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let labeledCheckbox = LabeledCheckbox(text: "This is a label checkbox")
`}</code></pre>
    <p>{`Checked Checkbox `}<img parentName="p" {...{
        "src": "/img/ios/checkbox_checked.png",
        "alt": "Checked Checkbox",
        "title": "Checked Checkbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let checkbox = Checkbox()
checkbox.isSelected = true
`}</code></pre>
    <p>{`Checked LabeledCheckbox `}<img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_checked.png",
        "alt": "Checked LabeledCheckbox",
        "title": "Checked LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let labeledCheckbox = LabeledCheckbox(text: "This is a labeled checkbox")
labeledCheckbox.isSelected = true
`}</code></pre>
    <p>{`Intermediate Checkbox `}<img parentName="p" {...{
        "src": "/img/ios/checkbox_intermediate.png",
        "alt": "Intermediate Checkbox",
        "title": "Intermediate Checkbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let checkbox = Checkbox()
checkbox.mark = .intermediate
`}</code></pre>
    <p>{`Intermediate LabeledCheckbox `}<img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_intermediate.png",
        "alt": "Intermediate LabeledCheckbox",
        "title": "Intermediate LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let labeledCheckbox = LabeledCheckbox(text: "This is a labeled checkbox")
labeledCheckbox.mark = .intermediate
`}</code></pre>
    <h2>{`Checkbox Properties`}</h2>
    <h3>{`isEnabled`}</h3>
    <p>{`If false, the user cannot interact with the checkbox and the checkbox will be gray.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/checkbox_disabled.png",
        "alt": "Disabled Checkbox",
        "title": "Disabled Checkbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`checkbox.isEnabled = false
`}</code></pre>
    <h3>{`isSelected`}</h3>
    <p>{`If true, the checkbox will be checked and blue.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/checkbox_checked.png",
        "alt": "Checked Checkbox",
        "title": "Checked Checkbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`checkbox.isSelected = false
`}</code></pre>
    <h3>{`mark`}</h3>
    <p>{`Defines the mark displayed inside the checkbox. Can be either `}<inlineCode parentName="p">{`empty`}</inlineCode>{`, `}<inlineCode parentName="p">{`checked`}</inlineCode>{` or `}<inlineCode parentName="p">{`intermediate`}</inlineCode>{`. The default value is `}<inlineCode parentName="p">{`empty`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`checkbox.mark = .intermediate
`}</code></pre>
    <h3>{`checkboxSize`}</h3>
    <p>{`This defines the width/height of the checkbox. The checkbox always has a square shape. The default value is 20.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`checkbox.checkboxSize = 32
`}</code></pre>
    <h2>{`LabeledCheckbox Properties`}</h2>
    <h4>{`text`}</h4>
    <p>{`Sets the text of the label.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.text = "This is a cool label checkbox!"
`}</code></pre>
    <h4>{`attributedText`}</h4>
    <p>{`Sets the attributed text of the label.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.attributedText = attributedString
`}</code></pre>
    <h4>{`textStyle`}</h4>
    <p>{`Sets the text style of the label.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.textStyle = .title1
`}</code></pre>
    <h4>{`contentInsets`}</h4>
    <p>{`Sets the content insets of the full control. The additional insets are part of the interactive area of the control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.contentInsets = UIEdgeInsets(left: 10, top: 10, bottom: 10, right: 10)
`}</code></pre>
    <h3>{`isEnabled`}</h3>
    <p>{`If false, the user cannot interact with the checkbox and the control will be gray.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_disabled.png",
        "alt": "Disabled LabeledCheckbox",
        "title": "Disabled LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.isEnabled = false
`}</code></pre>
    <h3>{`isSelected`}</h3>
    <p>{`If true, the checkbox will be checked and blue.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_checked.png",
        "alt": "Checked LabeledCheckbox",
        "title": "Checked LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.isSelected = false
`}</code></pre>
    <h4>{`contentPlacement`}</h4>
    <p>{`Determines on what side of the checkbox the label is shown. The default value is `}<inlineCode parentName="p">{`.trailing`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_left.png",
        "alt": "Left LabeledCheckbox",
        "title": "Left LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.contentPlacement = .leading
`}</code></pre>
    <h4>{`numberOfLines`}</h4>
    <p>{`Determines the number of lines for the label. The default is `}<inlineCode parentName="p">{`1`}</inlineCode>{`. When set to `}<inlineCode parentName="p">{`0`}</inlineCode>{` there will be as many lines as needed to display the full text.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_multiline.png",
        "alt": "Multiline LabeledCheckbox",
        "title": "Multiline LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.numberOfLines = 0
labeledCheckbox.text = "This is a labeled checkbox whose text will spread out over multiple lines because this text is too big to fit on one line"
`}</code></pre>
    <h4>{`hasError`}</h4>
    <p>{`I true, the checkbox and label will be red. Use this property if something’s wrong and the control needs a user’s attention.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/labelcheckbox_error.png",
        "alt": "Error LabeledCheckbox",
        "title": "Error LabeledCheckbox"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.hasError = true
`}</code></pre>
    <h3>{`mark`}</h3>
    <p>{`Defines the mark displayed inside the checkbox. Can be either `}<inlineCode parentName="p">{`empty`}</inlineCode>{`, `}<inlineCode parentName="p">{`checked`}</inlineCode>{` or `}<inlineCode parentName="p">{`intermediate`}</inlineCode>{`. The default value is `}<inlineCode parentName="p">{`empty`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.mark = .intermediate
`}</code></pre>
    <h3>{`checkboxSize`}</h3>
    <p>{`This defines the width/height of the checkbox. The checkbox always has a square shape. The default value is 20.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`labeledCheckbox.checkboxSize = 32
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      